import { render } from "./dbilling.vue?vue&type=template&id=048ac5af"
import script from "./dbilling.vue?vue&type=script&lang=js"
export * from "./dbilling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__